t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <h2>{{ $t("location.question") }}</h2>
      <div>
        <img
          class="count-image shadow"
          :src="require('@/assets/location.svg')"
        />
        <v-select
          v-model="location"
          :options="countryList"
          style="min-width: 160px"
        ></v-select>
      </div>
      <one-button
        type="primary"
        class="next-btn"
        :class="{ disabled: location === null }"
        @click.native="next()"
      >
        {{ $t("next") }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn">{{ $t('back') }}</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";
import { countryList, countryListDe } from "@/utils/countries.js";

export default {
  name: "Location",
  components: { CalculatorHeading },
  data() {
    return {
      step: getStepIndex("location"),
      getPrevStepUrl: getPrevStepUrl,
      location: this.$store.state.data.location
    };
  },
  computed: {
    countryList() {
      return this.$i18n.locale === "de" ? countryListDe : countryList;
    }
  },
  watch: {
    location: function() {
      this.updateLocation(this.location);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateLocation"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
.disabled {
  pointer-events: none;
}

.skip {
  color: #008c96;
  text-decoration: underline;
}
.skip:hover {
  cursor: pointer;
}
</style>
